import { cn } from '@/lib/utils'

interface TourActionsProps {
  children: React.ReactNode
  className?: string
  alignment?: 'left' | 'center' | 'right' | 'between'
}

export function TourActions({ children, className, alignment = 'right' }: TourActionsProps) {
  const alignmentClasses = {
    left: 'justify-start',
    center: 'justify-center',
    right: 'justify-end',
    between: 'justify-between',
  }

  return <div className={cn('flex items-center gap-2', alignmentClasses[alignment], className)}>{children}</div>
}
